import { Field } from 'ngx-angular-query-builder';
import { FieldMetadata, FilterOperators, FieldMetadataCollection, FilterFieldProvider } from '@common/filter/filtering';
import { VatRate } from '@feature/invoice-upload/models/vat-rate';
import { ArrayToFilterListItemBuilder } from '@common/filter/services/array-to-filter-list-item-builder';

export class AdminInvoiceStatusWidgetFilterFieldProvider implements FilterFieldProvider {

  private readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(vatRates: VatRate[], invoiceStatuses: string[]) {

    this.fieldMetaDataCollection = new FieldMetadataCollection();


    const addFilter = (label: string, field: string, type: string, ops: string[]) => {
      const filterField = {
        name: label,
        type: type,
        operators: ops
      };
      const fieldMeta = new FieldMetadata(field, filterField);
      this.fieldMetaDataCollection.set(label, fieldMeta);
      return fieldMeta;
    };

    const vatOptionBuilder = new ArrayToFilterListItemBuilder(vatRates);
    vatOptionBuilder.forProperty('VatRate', 'Code', (x: VatRate) => `${x.Code} - ${x.Description}`);
    const vatOptions = vatOptionBuilder.build();


    addFilter('Invoice Date', 'SystemInvoiceDate', 'date', FilterOperators.AdminDateDefaults);
    addFilter('Invoice Reference', 'SystemInvoiceReference', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Property Reference', 'SystemPropertyReference', 'number', FilterOperators.AdminScalar);
    addFilter('Property Address', 'SystemPropertyAddress', 'string', FilterOperators.AdminStringDefaults);
    addFilter('URN', 'SystemURN', 'number', FilterOperators.AdminScalar);

    addFilter('Narrative', 'SystemNarrative', 'string', FilterOperators.AdminStringDefaults);
    const fm = addFilter('Vat Rate', 'SystemVatRate', 'number', FilterOperators.Scalar);
    fm.field.options = vatOptions.get('VatRate');

    addFilter('Net Amount', 'SystemNetAmount', 'number', FilterOperators.AdminScalar);
    addFilter('Vat Amount', 'SystemVatAmount', 'number', FilterOperators.AdminScalar);
    addFilter('Gross Amount', 'SystemGrossAmount', 'number', FilterOperators.AdminScalar);
    addFilter('Currency', 'SystemCurrency', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Currency Description', 'SystemCurrencyDescription', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Payment Due Date', 'SystemPaymentDueDate', 'date', FilterOperators.AdminDateDefaults);

    const isfm = addFilter('Invoice Status', 'SystemInvoiceStatus', 'category', FilterOperators.CategoryDefaults);
    isfm.field.options = invoiceStatuses.map(i => ({label: i, name: i, value: i}) );

    addFilter('Payment Status', 'SystemPaymentStatus', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Payment Details', 'SystemPaymentDetails', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Date Paid', 'SystemDatePaid', 'date', FilterOperators.AdminDateDefaults);
    addFilter('Amount Paid', 'SystemAmountPaid', 'number', FilterOperators.AdminScalar);

  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }

}
